import {api} from "@/data/api/portal"

export interface EnvConfig {
  environmentId: string;
  region: string;

  dbHost: string;
  dbPort: string;
  dbInstance: string;
  iprHost: string;
  auditHost: string;
  dbValidationEnabled: boolean;

  authEnabled: boolean;
  authServiceVersion: string;
  authServiceDbUser: string;
  authServiceDbPassword: string;
  authWebVersion: string;

  portalsEnabled: boolean;
  portalsVersion: string;
  portalsDbUser: string;
  portalsDbPassword: string;

  macEnabled: boolean;
  macServiceVersion: string;
  macIprEnabled: boolean;
  macServiceDbUser: string;
  macServiceDbPassword: string;
  macFmEnabled: boolean;
  macServiceFmDbUser: string;
  macServiceFmDbPassword: string;
  macAuditEnabled: boolean;
  macServiceAuditDbUser: string;
  macServiceAuditDbPassword: string;
  macWebVersion: string;

  auditTrailEnabled: boolean;
  auditTrailVersion: string;
  auditTrailDbUser: string;
  auditTrailDbPassword: string;

  errorMessage?: string; // todo remove?
}

export interface EnvConfigSubmitResponse {
  id: string;
  errorMessage?: string;
}

export interface EnvConfigJobStatus {
  id: string;
  inProgress: boolean;
  currentAction: string;
  runningJobId: string;
  errorMessage?: string;
}

export async function getEnvConfig(environmentId: string) {
  // https://env-sandbox.micadipr.net/api/getEnvironmentConfig
  const r = await api.get("/getEnvironmentConfig", {params: {environmentId}})
  return r.data as EnvConfig
}

export async function setEnvConfig(data: EnvConfig) {
  // https://env-sandbox.micadipr.net/api/setEnvironmentConfig
  const r = await api.post("/setEnvironmentConfig", data)
  return r.data as EnvConfigSubmitResponse
}

export async function getEnvConfigStatusUpdate(jobId: string) {
  // https://env-sandbox.micadipr.net/api/environmentConfigStatus
  const r = await api.get("/environmentConfigStatus", {params: {id: jobId}})
  return r.data as EnvConfigJobStatus
}
